module.exports = {"id":"203619","name":"Nuno Henrique","rating":"71","photo":"./data/images/photos/1/203619.png","club":{"name":"Boavista","logo":"./data/images/clubs/Boavista.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NunoHenrique0.json
// module id = 3241
// module chunks = 0